import {
  CalendarOutlined,
  CheckCircleOutlined,
  DownOutlined,
  PlusCircleOutlined,
  ProfileOutlined,
} from "@ant-design/icons";
import { Dropdown, Button, Space, MenuProps } from "antd";
import { t } from "i18next";
import React from "react";
import { observer } from "mobx-react-lite";
import {
  createPlanFromTemplate,
  createGroupFromTemplate,
  createTaskFromTemplate,
} from "src/businessServices/services/bsScheduling/apiScheduling";
import { SchedTemplateCreator } from "./SchedTemplateCreator";
import { SchedulingControlStore } from "../../../SchedulingControlStore";

interface PropsSchedCreators {
  store: SchedulingControlStore;
}

export const SchedCreators: React.FC<PropsSchedCreators> = observer(
  ({ store }) => {
    const { settings, data, operationLoading } = store;
    if (!settings) return null;
    const {
      planTemplateSettings,
      groupTemplateSettings,
      taskTemplateSettings,
      taskSettings,
    } = settings;
    const planTemplateId = planTemplateSettings?.templateObjectId;
    const groupTemplateId = groupTemplateSettings?.templateObjectId;
    const taskTemplateId = taskTemplateSettings?.templateObjectId;
    const taskObjectId = taskSettings?.templateObjectId;

    const disabled = data.status !== "ready" || operationLoading;

    const menuProps: MenuProps = {
      items: [
        {
          key: "fromTemplate",
          label: t("From the template"),
          type: "group",
          children: [
            {
              key: "planTemplate",
              icon: <CalendarOutlined />,
              label: t("Plan"),
              disabled: !planTemplateId,
              onClick: () => {
                if (planTemplateId) {
                  store.openTemplateCreation(
                    planTemplateId,
                    t("Plan template"),
                    createPlanFromTemplate,
                  );
                }
              },
            },
            {
              key: "groupTemplate",
              icon: <ProfileOutlined />,
              label: t("Task group"),
              disabled: !groupTemplateId,
              onClick: () => {
                if (groupTemplateId) {
                  store.openTemplateCreation(
                    groupTemplateId,
                    t("Task group template"),
                    createGroupFromTemplate,
                  );
                }
              },
            },
            {
              key: "taskTemplate",
              icon: <CheckCircleOutlined />,
              label: t("Task"),
              disabled: !taskTemplateId,
              onClick: () => {
                if (taskTemplateId) {
                  store.openTemplateCreation(
                    taskTemplateId,
                    t("Task template"),
                    createTaskFromTemplate,
                  );
                }
              },
            },
          ],
        },
        { type: "divider" },
        {
          key: "task",
          icon: <PlusCircleOutlined />,
          label: t("Task without template"),
          disabled: !taskObjectId,
          onClick: () => {
            if (taskObjectId) {
              store.openCreation(taskObjectId);
            }
          },
        },
      ],
    };

    return (
      <>
        <Dropdown menu={menuProps} placement="bottomRight" disabled={disabled}>
          <Button type="primary">
            <Space>
              {t("Create")}
              <DownOutlined />
            </Space>
          </Button>
        </Dropdown>
        <SchedTemplateCreator store={store} />
      </>
    );
  },
);
